import React from 'react'
import './SHInput.css'

export default function SHInput({placeholder,value,onChange}) {
    return (
        <input
            type="text"
            className="sh-input"
            placeholder={placeholder}
            value={value}
            onChange={onChange}
        />
    )
}
